import users from './data/users.json';

const initialState = {
    users: users
}
const userData = (state = initialState, action) => {
    switch (action.type){
        case "add-user":
            const user ={
                _id: action.user.userId,
                "name": action.user.name,
                "email": action.user.email,
                "dateOfBirth" : action.user.dateOfBirth,
                "userId": action.user.userId,
                "password": action.user.password,

            }
            return ({
                users: [
                    user,
                    ...state.users,
                ]
            });

        default:
            return({users:state.users});
    }
};

export default userData;
